import { memo, useContext } from 'react';
import { useFieldArray } from 'react-hook-form';

import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';
import { GetOptionTranslationMap } from 'constants/guidelineRules';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import PhotoModelField from '../../photoModelField';

const PhotoModelHalfField = () => {
  const { guidelineRuleFormMethods } = useContext(CampaignFormContext);

  const photoModelHalf = useFieldArray({
    control: guidelineRuleFormMethods.control,
    name: GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_HALF,
  });

  const decrement = () => {
    photoModelHalf.remove(photoModelHalf.fields.length - 1);
  };

  const increment = () => {
    photoModelHalf.append({
      value: '',
    });
  };

  return (
    <PhotoModelField
      label={GetOptionTranslationMap(
        GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_HALF,
      )}
      count={photoModelHalf.fields.length}
      border
      decrement={decrement}
      increment={increment}
    />
  );
};

export default memo(PhotoModelHalfField);
